import type { Season } from '@features/seasonal-theme/types';

import { SEASON_ICONS, svgToDataUri } from '@features/seasonal-theme/utils/season-icons';

type Props = { season: Season; size?: number };

export const SeasonIcon = ({ season, size = 24 }: Props) => {
  const icon = svgToDataUri(SEASON_ICONS[season.id]);
  const mask = `${icon} center / contain no-repeat`;

  return (
    <span
      aria-hidden
      className="block shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: season.decorationColor ?? season.palette.primary.main,
        mask,
        WebkitMask: mask,
      }}
    />
  );
};
